<template>
  <div v-loading="loading" element-loading-text="加载中...">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="APP推广" prop="appTui">
        <el-input v-model="dataForm.appTui" placeholder="APP推广URL" class="input-item"></el-input>
      </el-form-item>

      <el-form-item label="显示公告" prop="showPopup">
        <el-radio-group v-model="dataForm.showPopup">
          <el-radio :label="0">不显示</el-radio>
          <el-radio :label="1">显示</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="公告内容" prop="popupContent" >
        <el-input
          v-model="dataForm.popupContent"
          type="textarea"
          :rows="3"
          placeholder="公告显示内容"
          class="input-item">
        </el-input>
      </el-form-item>

      <el-form-item label="试看秒数" prop="shikan">
        <el-input-number
          v-model="dataForm.shikan"
          :min="0"
          :max="300"
          placeholder="试看秒数"
          class="input-item">
        </el-input-number>
        <span class="form-tip">单位:秒</span>
      </el-form-item>

      <el-form-item label="LOGO" prop="appLogo">
        <ImageUpload :limit="1"
          v-model="dataForm.appLogo"
          :file-size="5"
          :file-type="['png', 'jpg', 'jpeg', 'gif','webp']"
          :is-show-tip="true"
        />
      </el-form-item>
      <el-form-item label="IOS下载" prop="appIosUrl">
        <el-input v-model="dataForm.appIosUrl" placeholder="IOS下载地址" class="input-item"></el-input>
      </el-form-item>

      <el-form-item label="安卓下载域名" prop="arguments">
        <el-input v-model="dataForm.arguments" placeholder="例如: https://91porndown.cc/download" class="input-item"></el-input>
        <span class="form-tip">上传APK前必须先配置此域名</span>
      </el-form-item>

      <el-form-item label="安卓APK上传" prop="apkFile">
        <el-upload
          ref="apkUpload"
          class="apk-uploader"
          :action="uploadUrl"
          :headers="uploadHeaders"
          :before-upload="beforeApkUpload"
          :on-success="handleApkSuccess"
          :on-error="handleApkError"
          :on-progress="handleApkProgress"
          :show-file-list="false"
          accept=".apk"
          :disabled="uploading">
          <el-button size="small" type="primary" :loading="uploading" :disabled="uploading">
            <i class="el-icon-upload" v-if="!uploading"></i>
            {{ uploading ? `上传中 ${uploadProgress}%` : '选择APK文件' }}
          </el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传.apk文件,且不超过500MB
          </div>
        </el-upload>
        <div v-if="dataForm.appAndroidUrl" class="apk-info">
          <el-tag type="success">当前APK下载地址</el-tag>
          <el-input v-model="dataForm.appAndroidUrl"  class="input-item" style="margin-top: 10px;">
            <el-button slot="append" icon="el-icon-document-copy" @click="copyUrl(dataForm.appAndroidUrl)">复制</el-button>
          </el-input>
        </div>
      </el-form-item>

      <el-form-item label="开屏广告" prop="showAd">
        <el-radio-group v-model="dataForm.showAd">
          <el-radio :label="0">不显示</el-radio>
          <el-radio :label="1">显示</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="开屏广告时长" prop="showAdTime" >
        <el-input-number
          v-model="dataForm.showAdTime"
          :min="1"
          :max="10"
          placeholder="默认3秒"
          class="input-item">
        </el-input-number>
        <span class="form-tip">单位:秒,建议1-10秒</span>
      </el-form-item>

      <el-form-item label="广告跳转" prop="adUrl" >
        <el-input v-model="dataForm.adUrl" placeholder="开屏广告跳转的url" class="input-item"></el-input>
      </el-form-item>
      <el-form-item label="广告图片" prop="adImg">
        <ImageUpload :limit="1"
          v-model="dataForm.adImg"
          :file-size="5"
          :file-type="['png', 'jpg', 'jpeg', 'gif','webp']"
          :is-show-tip="true"
        />
      </el-form-item>
      <el-form-item label="VIP广告" prop="showVipBuyAd">
        <el-radio-group v-model="dataForm.showVipBuyAd">
          <el-radio :label="0">不显示</el-radio>
          <el-radio :label="1">显示</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="VIP广告图片" prop="vipAdImg">
        <ImageUpload :limit="1"
          v-model="dataForm.vipAdImg"
          :file-size="5"
          :file-type="['png', 'jpg', 'jpeg', 'gif','webp']"
          :is-show-tip="true"
        />
      </el-form-item>
      <el-form-item label="显示二级子分类" prop="showSonType">
        <el-radio-group v-model="dataForm.showSonType">
          <el-radio :label="0">不显示</el-radio>
          <el-radio :label="1">显示</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="在线坐席" prop="seatUrl">
        <el-input v-model="dataForm.seatUrl" placeholder="在线客服地址" class="input-item"></el-input>
      </el-form-item>

      <el-form-item label="网站名字" prop="appName">
        <el-input v-model="dataForm.appName" placeholder="网站名字" class="input-item" maxlength="50"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="dataFormSubmitHandle()" :loading="submitting">
          {{ submitting ? '保存中...' : $t('confirm') }}
        </el-button>
        <el-button @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      imageType: ['jpg', 'jpeg', 'png', 'gif', 'bmp','webp'],
      loading: false,
      submitting: false,
      uploading: false,
      uploadProgress: 0,
      adImg: '',
      appLogo: '',
      vipAdImg: '',
      dataForm: {
        id: '',
        seatUrl: '',
        appTui: '',
        shikan: 0,
        appAndroidUrl: '',
        appIosUrl: '',
        appLogo: '',
        arguments: '',
        showPopup: 0,
        popupContent: '',
        showAd: 0,
        showAdTime: 3,
        adUrl: '',
        adImg: '',
        showVipBuyAd: 0,
        vipAdImg: '',
        showSonType: 0,
        appName: ''
      }
    }
  },
  computed: {
    // APK上传地址
    uploadUrl() {
      return `${process.env.VUE_APP_API_TARGET}${process.env.VUE_APP_BASE_API}/appconfig/appconfig/uploadApk`
    },
    // 上传请求头
    uploadHeaders() {
      return {
        token: Cookies.get('token')
      }
    },
    dataRule () {
      return {
        appName: [
          { required: true, message: '网站名字不能为空', trigger: 'blur' }
        ],
        popupContent: [
          { required: this.dataForm.showPopup === 1, message: '公告内容不能为空', trigger: 'blur' }
        ],
        shikan: [
          { required: true, message: '试看秒数不能为空', trigger: 'blur' },
          { type: 'number', min: 0, message: '试看秒数不能小于0', trigger: 'blur' }
        ],
        showAdTime: [
          { required: this.dataForm.showAd === 1, message: '开屏广告时长不能为空', trigger: 'blur' },
          { type: 'number', min: 1, max: 10, message: '开屏广告时长建议1-10秒', trigger: 'blur' }
        ],
        adImg: [
          { required: this.dataForm.showAd === 1, message: '广告图片不能为空', trigger: 'change' }
        ],
        vipAdImg: [
          { required: this.dataForm.showVipBuyAd === 1, message: 'VIP广告图片不能为空', trigger: 'change' }
        ],
        arguments: [
          { required: false, message: '请先配置安卓下载域名', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$nextTick(() => {
        this.getInfo()
      })
    },
    // 开屏广告图片上传成功
    successHandle (fileList) {
      if (fileList.length > 0) {
        this.adImg = fileList[0].url
      } else {
        this.adImg = ''
      }
      this.dataForm.adImg = this.adImg
    },
    // Logo上传成功
    successHandleLogo (fileList) {
      if (fileList.length > 0) {
        this.appLogo = fileList[0].url
      } else {
        this.appLogo = ''
      }
      this.dataForm.appLogo = this.appLogo
    },
    // VIP广告图片上传成功
    successHandleVipAd (fileList) {
      if (fileList.length > 0) {
        this.vipAdImg = fileList[0].url
      } else {
        this.vipAdImg = ''
      }
      this.dataForm.vipAdImg = this.vipAdImg
    },
    // 获取信息
    getInfo () {
      this.loading = true
      this.$http.get(`/appconfig/appconfig/getInfo`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        // 同步图片显示
        this.appLogo = res.data.appLogo || ''
        this.adImg = res.data.adImg || ''
        this.vipAdImg = res.data.vipAdImg || ''
      }).catch(() => {}).finally(() => {
        this.loading = false
      })
    },
    // 重置表单
    resetForm () {
      this.$refs['dataForm'].resetFields()
      this.getInfo()
    },
    // APK上传前的校验
    beforeApkUpload(file) {
      // 检查是否配置了下载域名
      if (!this.dataForm.arguments || this.dataForm.arguments.trim() === '') {
        this.$message.error('请先配置安卓下载域名')
        return false
      }

      // 检查文件类型
      const isApk = file.name.toLowerCase().endsWith('.apk')
      if (!isApk) {
        this.$message.error('只能上传APK文件')
        return false
      }

      // 检查文件大小 (500MB = 500 * 1024 * 1024 bytes)
      const isLt500M = file.size / 1024 / 1024 < 500
      if (!isLt500M) {
        this.$message.error('APK文件大小不能超过500MB')
        return false
      }

      this.uploading = true
      this.uploadProgress = 0
      return true
    },
    // APK上传进度
    handleApkProgress(event) {
      this.uploadProgress = Math.floor(event.percent)
    },
    // APK上传成功
    handleApkSuccess(response) {
      this.uploading = false
      this.uploadProgress = 0

      if (response.code === 0) {
        this.$message.success('APK上传成功')
        // 更新下载地址
        this.dataForm.appAndroidUrl = response.data.fullUrl
        // 刷新数据
        this.getInfo()
      } else {
        this.$message.error(response.msg || 'APK上传失败')
      }
    },
    // APK上传失败
    handleApkError(err) {
      this.uploading = false
      this.uploadProgress = 0
      this.$message.error('APK上传失败,请重试')
      console.error('APK上传错误:', err)
    },
    // 复制下载地址
    copyUrl(url) {
      const input = document.createElement('input')
      input.value = url
      document.body.appendChild(input)
      input.select()
      try {
        document.execCommand('copy')
        this.$message.success('下载地址已复制到剪贴板')
      } catch (err) {
        this.$message.error('复制失败,请手动复制')
      }
      document.body.removeChild(input)
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.submitting = true
        this.$http[!this.dataForm.id ? 'post' : 'put']('/appconfig/appconfig/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.getInfo()
            }
          })
        }).catch(() => {}).finally(() => {
          this.submitting = false
        })
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>

<style scoped>
  .input-item {
    width: 400px;
  }
  .form-tip {
    margin-left: 10px;
    color: #909399;
    font-size: 12px;
  }

  /* APK上传相关样式 */
  .apk-uploader {
    display: inline-block;
  }

  .apk-info {
    margin-top: 15px;
    padding: 15px;
    background: #f5f7fa;
    border-radius: 4px;
    border: 1px solid #e4e7ed;
  }

  .apk-info .el-tag {
    margin-bottom: 10px;
  }

  .el-upload__tip {
    color: #909399;
    font-size: 12px;
    margin-top: 7px;
  }
</style>
